import { createAction, props } from "@ngrx/store";
import { BreecePermissions } from "../../services/api-services/permissions/models/breece-permission.model";

export namespace SecurityStateAction {

  // Permissions
  export const getInstallationPermissions = createAction(
    '[SecurityState] Get Installation Permissions'
  )
  export const getInstallationPermissionsSuccess = createAction(
    '[SecurityState] Get Installation Permissions success',
    props<{
      installationPermissions: BreecePermissions | null
      systemPermissions: BreecePermissions | null
    }>()
  )
  export const getInstallationPermissionsFailed = createAction(
    '[SecurityState] Get Installation Permissions Failed',
    props<{ error: string }>(),
  )

  // System permissions — loaded independently of any installation context (used by the admin
  // panel guard on the global /admin route). Reuses getInstallationPermissionsFailed
  // for the error path.
  export const getSystemPermissions = createAction(
    '[SecurityState] Get System Permissions'
  )
  export const getSystemPermissionsSuccess = createAction(
    '[SecurityState] Get System Permissions success',
    props<{ systemPermissions: BreecePermissions | null }>()
  )

}
